import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const DirectSalesLanding = {
  Header: lazy(
    () => import('components/second-quote/components/SecondQuoteHeader')
  ),
  Content: lazy(
    () => import('components/second-quote/components/SecondQuoteContent')
  )
};

export default DirectSalesLanding;
